// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Admin_wrapper__1ZbgJ","contentWrapper":"Admin_contentWrapper__2PQg1"};